import { Box, SkeletonGroup, SkeletonRectangle, Tag, Text, Tooltip } from '@wix/design-system';
import { CoreDomainSearchBackend } from '@wix/core-domain-search';
import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { GiftSmall } from '@wix/wix-ui-icons-common/lazy';
import clsx from 'clsx';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { GateTldChipsDataHooks } from './dataHooks';
import s from './gateTldChips.scss';
import { TLDS_LIMIT, useTldPress } from '../../hooks/useTldPress';
const VOUCHER_TOOLTIP_KEY = 'domains_search_gate.gate_revamp.tld_chips.voucher.tooltip';
const SKELETON_CHIP_WIDTH = '72px';
const ChipsRowSkeleton = () => /*#__PURE__*/React.createElement(SkeletonGroup, {
  skin: "light"
}, /*#__PURE__*/React.createElement(Box, {
  dataHook: GateTldChipsDataHooks.skeleton,
  className: s.skeletonRow,
  gap: "6px",
  align: "center",
  verticalAlign: "middle",
  flexWrap: "wrap",
  width: "100%"
}, Array.from({
  length: TLDS_LIMIT
}, (_, index) => /*#__PURE__*/React.createElement(SkeletonRectangle, {
  key: index,
  width: SKELETON_CHIP_WIDTH,
  height: "30px"
}))));
export const GateTldChips = () => {
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const selectedTlds = CoreDomainSearchStore.useTlds();
  const {
    data,
    isLoading
  } = CoreDomainSearchBackend.hooks.useGetTldSelectorData({
    limit: TLDS_LIMIT
  }, true, {
    cacheTime: Infinity,
    staleTime: Infinity,
    useErrorBoundary: false,
    suspense: false,
    retry: false
  });
  const availableTlds = (data == null ? void 0 : data.tldSelectorData) ?? [];
  const press = useTldPress();
  const handleClick = (tld, position) => {
    press(tld, {
      position,
      numOfTlds: availableTlds.length
    });
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(ChipsRowSkeleton, null);
  }
  if (!availableTlds.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: GateTldChipsDataHooks.row,
    gap: "6px",
    align: "center",
    verticalAlign: "middle",
    flexWrap: "wrap",
    width: "100%"
  }, availableTlds.map((_ref, index) => {
    let {
      tld,
      isVoucherSupported
    } = _ref;
    const chip = /*#__PURE__*/React.createElement(Tag, {
      id: tld,
      skin: "lightOutlined",
      removable: false,
      className: clsx(s.tldChip, {
        [s.tldChipSelected]: selectedTlds.includes(tld)
      }),
      onClick: () => handleClick(tld, index + 1),
      dataHook: `${GateTldChipsDataHooks.option}-${tld}`
    }, /*#__PURE__*/React.createElement(Box, {
      gap: "6px",
      direction: "horizontal",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, ".", tld), isVoucherSupported && /*#__PURE__*/React.createElement(GiftSmall, null)));
    if (!isVoucherSupported) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: tld
      }, chip);
    }
    return /*#__PURE__*/React.createElement(Tooltip, {
      key: tld,
      size: "medium",
      placement: "bottom",
      textAlign: "center",
      maxWidth: "202px",
      content: t(VOUCHER_TOOLTIP_KEY, {
        tld: `.${tld}`
      })
    }, chip);
  }));
};
//# sourceMappingURL=GateTldChips.js.map